module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "introduction"
    }
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "fmlev1"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5"
    }
  }, [_c('img', {
    staticClass: "in100",
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  }), _c('br'), _vm._v("HOW TO USE THIS BOOK"), _c('br'), _c('img', {
    staticClass: "in100",
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("This book is divided into five main sections: Borders, Banners & Letters; Botanicals; Architecture & City Life; Animals & Insects; and Everyday Life. Each section is designed to teach you how to draw different types of objects within that theme. Most sections start with basic objects and become more advanced as you progress.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("You’ll also find step-by-step instructions on how to draw a variety of objects and give them unique features and personality by adding details. These instructions are meant to be used as a guide—you don’t have to draw exactly what I draw, but you can if you like! And you can always follow the foundational principles in building the illustration and add your own personal twist in the details. I highly encourage you to doodle in this book, draw in the margins, make notes, and practice the different techniques in your own sketchbook. Practice really does make perfect!")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("You’ll find practice pages where you can try your hand at what you’ve learned. Explore anything that fits the theme! Want to practice drawing the paws of animals? Go for it. Really want to draw a llama? Pull up a reference and try it! This is your free space.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Each section also includes a creative prompt to spark the imagination and encourage you to take what you’ve learned and get really creative.")]), _vm._v(" "), _c('div', {
    staticClass: "ft50"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "id": "f0005-01.jpg",
      "src": "images/f0005-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("By the time you’ve worked your way through this book, you’ll feel more confident about incorporating drawing into your everyday life and more self-assured about illustrating complex items and objects—and hopefully you will have had a lot of fun!")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Are you ready to begin? Onward!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-759e2e48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm1.vue
// module id = 66
// module chunks = 0